import { Component, ViewChild } from '@angular/core';
import { FileTypeConstants } from '../../../../shared/constants/file-upload-type-constants';
import { FileUploadComponent } from '../../../../shared/file-upload/file-upload.component';

@Component({
  selector: 'trip-reimbursement-info',
  templateUrl: './trip-reimbursement-info.component.html'
})
export class TripReimbursementInfoComponent {
  @ViewChild(FileUploadComponent) fileUpload: FileUploadComponent;

  public acceptedFiles: string[] = [FileTypeConstants.txt, FileTypeConstants.doc, FileTypeConstants.docx, FileTypeConstants.pdf, FileTypeConstants.jpeg, FileTypeConstants.jpg, FileTypeConstants.png, FileTypeConstants.PNG, FileTypeConstants.gif];
  
  public get formCompleted(): boolean {
    // console.count('TripReimbursementInfoComponent.formCompleted getter called');
    return this.fileUpload.formCompleted;
  };
  public get importFiles(): File[] {
    // console.count('TripReimbursementInfoComponent.importFiles getter called');
    return this.fileUpload.importFiles;
  }

  constructor() { }

  public validateForm(): void {
    this.fileUpload.validateForm();
  }
}